
/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 *
 */

//	const host = 'http://47.107.86.206:8080/' //测试
//	const host = 'http://192.168.1.36:8080/' //测试
//	const host = 'http://120.79.220.94:8081/'  //正式
//	const host = 'http://192.168.1.250:8089'  //本地测试
//	const hostInvetory = 'http://test.wms.lacyai.cn'  //盘点测试
//	const hostInvetory = 'http://120.79.220.94'; //盘点正式
let host, hostInvetory
const imgBaseUrl = ''
const configuredWmsHost = process.env.PDA_API_BASE_URL || ''
const localWmsHost = typeof window !== 'undefined'
  ? `${window.location.protocol}//${window.location.hostname}:8082/`
  : 'http://127.0.0.1:8082/'
const demoWmsHost = configuredWmsHost || localWmsHost

if (process.env.NODE_ENV === 'development') {
  // 开发环境
  // host = 'http://192.168.1.234:8080/' // 测试
  // host = 'http://wms4j.lacyai.cn'
  host = demoWmsHost
  hostInvetory = demoWmsHost
  // hostInvetory = 'http://192.168.1.112/WMS/api'
} else {
  // 测试环境
  if (process.env.type === 'test') {
    host = 'http://47.107.86.206:8080/'
    // host = 'http://192.168.1.234:8080/'
    hostInvetory = 'http://test.wms.lacyai.cn/'
  } else {
    // 正式环境
    host = demoWmsHost
    hostInvetory = demoWmsHost
  }
}

export {
  host,
  hostInvetory,
  imgBaseUrl
}



// WEBPACK FOOTER //
// ./src/config/env.js